<app-gdpr-banner [attr.inert]="isLoading() || null" />

@if (!navBarShown && !isModifiedVersionBannerPage) {
  <ng-container *ngTemplateOutlet="versionBannerTemplate" />
}
@if (navBarShown) {
  <app-nav-header [attr.inert]="isLoading() || null" (menuClicked)="toggleSideNav()" />
}
<mat-sidenav-container [attr.inert]="isLoading() || null">
  <mat-sidenav #appSidenav [opened]="sidenavVisible()" (closedStart)="hideSideNav()">
    @if (navBarShown) {
      <app-mobile-nav (navigated)="hideSideNav()" />
    }
  </mat-sidenav>
  <mat-sidenav-content ngClass.lt-sm="mobile">
    @if (navBarShown || isModifiedVersionBannerPage) {
      <ng-container *ngTemplateOutlet="versionBannerTemplate" />
    }
    <router-outlet role="main" />
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #versionBannerTemplate>
  <app-version-sync-banner #bannerNavbar [attr.inert]="isLoading() || null" />
</ng-template>

<app-logout-idle [isActive]="navBarShown" />
